module.exports = __webpack_public_path__ + "static/img/hexibanner1.3c70e5b4.jpg";